var FireHour = function (src) {
    var self = this;
    src = src || {};
    self.FireHourId = src.FireHourId || 0;
    self.StudentId = src.StudentId || 0; 
    self.CalendarYear = src.CalendarYear || 0;
    self.FirstName = src.FirstName || '';
    self.MiddleInitial = src.MiddleInitial || '';
    self.LastName = src.LastName || '';
    self.ProjectId = src.ProjectId || 0;
    self.ProjectOrganizationName = src.ProjectOrganizationName || '';
    self.ProjectTitle = src.ProjectTitle || '';
    self.ProjectSubTitle = src.ProjectSubTitle || '';
    self.DispatchDate = src.DispatchDate || '';
    self.DateReturned = src.DateReturned || '';
    self.AnticipatedDurationInDays = src.AnticipatedDurationInDays || 0;
    self.EstimatedHours = src.EstimatedHours || 0;
    self.Hours = src.Hours || 0;
    self.ResourceId = src.ResourceId || 0;
    self.ResourceName = src.ResourceName || '';
    self.ForestName = src.ForestName || '';
    self.HoursTypeId = src.HoursTypeId || 0;
    self.TypeOfHours = src.TypeOfHours || '';
    self.Comments = src.Comments || '';
    self.IsPLC = src.IsPLC || true;
    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
    self.CreatedDate = src.CreatedDate || new Date();
    self.CreatedDateString = src.CreatedDateString || '';
    self.CreatedBy = src.CreatedBy || '';
    self.LastUpdated = src.LastUpdated || new Date();
    self.LastUpdatedString = src.LastUpdatedString || '';
    self.LastUpdatedBy = src.LastUpdatedBy || '';
    self.UpdatingApp = src.UpdatingApp || '';
    return self;
};
FireHour.prototype.fullName = function () {
    return (this.LastName || '') + ', ' + this.FirstName + ' ' + (this.MiddleInitial || '');
};
FireHour.prototype.dispatchDateISO = function () {
    if (this.DispatchDate == '')
        return '';
    else
        return new Date(this.DispatchDate);
};
FireHour.prototype.returnedDateISO = function () {
    if (this.DateReturned == '')
        return '';
    else
        return new Date(this.DateReturned);
};
angular.module('jcsfApp').value('FireHour', FireHour);